import React from 'react';

const HeaderSection = ({ tittle }) => {
  return (
    <>
      <div
        style={{
          // backgroundColor: 'rgb(10, 136, 117)',
          // color: 'rgba(255, 255, 255, 1)',
          // position: 'relative',
          // height: '100px',
          backgroundImage: 'linear-gradient(#2f77ff, #26aeff)',
          position: 'absolute',

          display: 'block',
          height: '40px',
          paddingRight: '20px',
          paddingLeft: '20px',
          fontWeight: 'bold',
          paddingTop: '0px',
        }}
      >
        <p
          style={{
            margin: '8px 0px 0px 0px',
            color: 'white',
          }}
        >
          {tittle}
        </p>
      </div>
      <br />
      <br />
      <br />
    </>
  );
};

export default HeaderSection;
